module.exports = __webpack_public_path__ + "static/mr-press-08-989de10ebace65bbe19111c2357aafa1.jpg";